// What the back office says as it happens (Oct 2026), in words. The feed (`GET /alerts/feed`)
// says what's new; this decides what's worth saying, once.
import { qty } from './units';

const money = (v) => new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(v || 0);

// An item that's low is said once a session: a stock count that leaves it still low, or a
// price change, touches it again, and that isn't news.
export function newLow(items, said) {
  return (items || []).filter((i) => !said.has(i.id));
}

// Orders the page hasn't said yet. The feed looks back a while before the last ask, because
// orders reach the Cloud by sync, so the same order can come back more than once.
export function newOrders(orders, said) {
  return (orders || []).filter((o) => !said.has(o.id));
}

// `more`: the feed hit its cap, so the count is a floor ("10+"), not the count.
export function lowWords(items, more = false) {
  if (!items.length) return null;
  if (items.length === 1 && !more) return `${items[0].name} is running low: ${qty(items[0].quantity, items[0].unit)} left`;
  return `${items.length}${more ? '+' : ''} items are running low: ${items.slice(0, 3).map((i) => i.name).join(', ')}${items.length > 3 || more ? '…' : ''}`;
}

export function orderWords(orders, more = false) {
  if (!orders.length) return null;
  // Past the cap the total of the ones shown isn't the total, so it isn't given.
  if (more) return `${orders.length}+ new orders`;
  if (orders.length === 1) {
    const o = orders[0];
    const where = o.table_name || (o.table_number ? `Table ${o.table_number}` : o.order_type === 'bar' ? 'The bar' : 'An order');
    return `New order: ${where} · ${money(o.total)}`;
  }
  return `${orders.length} new orders · ${money(orders.reduce((t, o) => t + (Number(o.total) || 0), 0))}`;
}
